import { get } from "./api"; // assuming you have this helper implemented

export const fetchDashboardData = async () => {
  try {
    const response = await get("/dashboard");
    console.log("Raw /dashboard response:", response);
    return response;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};



export const fetchTestAttempts = async () => {
  try {
    const endpoint = `/test/attempts?page=1&limit=5&minScore=0&maxScore=0`;
    console.log("endpoint",endpoint);
    const response = await get(endpoint);
    console.log("Raw /test/attempts response:", response);
    return response;
  } catch (error) {
    console.error("Error fetching test attempts:", error);
    throw error;
  }
};

export default {
  fetchDashboardData,
  fetchTestAttempts
};
